/**
 * Données et service de suivi de livraison
 * Agrège les informations de tracking des APIs partenaires
 */

/* ─── Statuts de commande ─────────────────────────────────── */
export const ORDER_STATUS = {
  PENDING:    { id: 'pending',    label: 'En attente',      labelEn: 'Pending',     color: '#854F0B', bg: '#FAEEDA', icon: '⏳' },
  CONFIRMED:  { id: 'confirmed',  label: 'Confirmée',       labelEn: 'Confirmed',   color: '#534AB7', bg: '#EEEDFE', icon: '✅' },
  PREPARING:  { id: 'preparing',  label: 'En préparation',  labelEn: 'Preparing',   color: '#185FA5', bg: '#E6F1FB', icon: '📦' },
  SHIPPED:    { id: 'shipped',    label: 'Expédiée',        labelEn: 'Shipped',     color: '#0F6E56', bg: '#E1F5EE', icon: '🚚' },
  IN_TRANSIT: { id: 'in_transit', label: 'En transit',      labelEn: 'In transit',  color: '#0F6E56', bg: '#E1F5EE', icon: '🌍' },
  OUT_FOR_DELIVERY: { id: 'out_for_delivery', label: 'En cours de livraison', labelEn: 'Out for delivery', color: '#639922', bg: '#EAF3DE', icon: '🛵' },
  DELIVERED:  { id: 'delivered',  label: 'Livrée',          labelEn: 'Delivered',   color: '#085041', bg: '#E1F5EE', icon: '🏠' },
  CANCELLED:  { id: 'cancelled',  label: 'Annulée',         labelEn: 'Cancelled',   color: '#791F1F', bg: '#FCEBEB', icon: '❌' },
  RETURNED:   { id: 'returned',   label: 'Retournée',       labelEn: 'Returned',    color: '#888780', bg: '#F1EFE8', icon: '↩️' },
};

/* ─── Délais de livraison par partenaire et région ─────────── */
export const DELIVERY_ESTIMATES = {
  zalando:     { EU: '2–4 j', US: null,     SEA: null,    express: '1–2 j',  free_threshold: 24.90 },
  asos:        { EU: '3–5 j', US: '5–7 j',  SEA: '7–14 j',express: '1–2 j', free_threshold: 0 },
  net_a_porter:{ EU: '1–3 j', US: '2–4 j',  ME: '3–5 j',  express: 'J+1',   free_threshold: 150 },
  farfetch:    { EU: '2–5 j', US: '3–6 j',  SEA: '5–10 j',express: '1–2 j', free_threshold: 100 },
  hm:          { EU: '3–5 j', US: null,     SEA: '7–14 j',express: null,    free_threshold: 0 },
  mango:       { EU: '2–5 j', US: '5–8 j',  ME: '5–10 j', express: '2–3 j', free_threshold: 0 },
  amazon:      { EU: '1–3 j', US: '1–2 j',  SEA: '5–10 j',express: 'J+1',   free_threshold: 0 },
  nordstrom:   { EU: null,    US: '2–5 j',  CA: '3–7 j',  express: '1–2 j', free_threshold: 89 },
  revolve:     { EU: '4–7 j', US: '2–4 j',  SEA: '7–14 j',express: '2–3 j', free_threshold: 100 },
  namshi:      { ME: '1–3 j', EU: null,     SEA: null,    express: 'J+1',   free_threshold: 0 },
  ounass:      { ME: '1–2 j', EU: null,     SEA: null,    express: 'J+1',   free_threshold: 200 },
  shopee:      { SEA: '2–5 j',EU: null,     IN: null,     express: '1–2 j', free_threshold: 0 },
  lazada:      { SEA: '2–7 j',EU: null,     IN: null,     express: '1–3 j', free_threshold: 0 },
  zalora:      { SEA: '3–5 j',EU: null,     IN: null,     express: '1–2 j', free_threshold: 0 },
  tokopedia:   { ID: '2–5 j', EU: null,     SEA: '3–7 j', express: '1–2 j', free_threshold: 0 },
  myntra:      { IN: '3–7 j', EU: null,     SEA: null,    express: '1–2 j', free_threshold: 0 },
  rakuten_jp:  { JP: '2–5 j', EU: null,     SEA: null,    express: '1–2 j', free_threshold: 0 },
  zozotown:    { JP: '1–3 j', EU: null,     SEA: null,    express: 'J+1',   free_threshold: 0 },
  coupang:     { KR: '1–2 j', EU: null,     SEA: null,    express: 'J+1',   free_threshold: 0 },
  musinsa:     { KR: '2–4 j', EU: null,     SEA: null,    express: '1–2 j', free_threshold: 0 },
};

/* ─── Commandes mock ──────────────────────────────────────── */
export const mockOrders = [
  {
    id: 'ord_001',
    date: '2026-04-10T14:30:00',
    status: 'in_transit',
    lines: [
      {
        id: 'line_1',
        emoji: '👗', name: 'Robe satin noir',
        partner: 'Net-a-Porter', partnerId: 'net_a_porter',
        price: 340, size: 'T.38',
        status: 'in_transit',
        trackingNumber: 'DHL1234567890',
        carrier: 'DHL Express',
        estimatedDelivery: '2026-04-14',
        events: [
          { date: '2026-04-10T14:35:00', label: 'Commande confirmée',        location: 'Net-a-Porter UK' },
          { date: '2026-04-11T09:00:00', label: 'Article préparé',           location: 'Entrepôt Luton, UK' },
          { date: '2026-04-11T18:20:00', label: 'Pris en charge par DHL',    location: 'DHL Heathrow' },
          { date: '2026-04-12T07:45:00', label: 'En transit international',  location: 'Hub DHL Paris CDG' },
        ],
      },
    ],
    total: 340, deliveryAddress: 'Sofia · 12 rue de la Paix, 75001 Paris',
  },
  {
    id: 'ord_002',
    date: '2026-04-08T10:00:00',
    status: 'delivered',
    lines: [
      {
        id: 'line_2',
        emoji: '👠', name: 'Escarpins cuir nude',
        partner: 'Zalando', partnerId: 'zalando',
        price: 129, size: 'T.38',
        status: 'delivered',
        trackingNumber: 'ZLD9876543210',
        carrier: 'DPD',
        estimatedDelivery: '2026-04-10',
        deliveredAt: '2026-04-10T11:30:00',
        events: [
          { date: '2026-04-08T10:05:00', label: 'Commande confirmée',    location: 'Zalando DE' },
          { date: '2026-04-08T16:00:00', label: 'Article préparé',       location: 'Entrepôt Erfurt, DE' },
          { date: '2026-04-09T08:30:00', label: 'Expédié',               location: 'DPD Erfurt' },
          { date: '2026-04-10T07:00:00', label: 'En cours de livraison', location: 'DPD Paris 75001' },
          { date: '2026-04-10T11:30:00', label: '✓ Livré',               location: '12 rue de la Paix, Paris' },
        ],
      },
    ],
    total: 129, deliveryAddress: 'Sofia · 12 rue de la Paix, 75001 Paris',
  },
  {
    id: 'ord_003',
    date: '2026-04-12T09:00:00',
    status: 'confirmed',
    lines: [
      {
        id: 'line_3',
        emoji: '💎', name: 'Collier fin doré',
        partner: 'ASOS', partnerId: 'asos',
        price: 48, size: 'Unique',
        status: 'confirmed',
        trackingNumber: null,
        carrier: null,
        estimatedDelivery: '2026-04-17',
        events: [
          { date: '2026-04-12T09:05:00', label: 'Commande confirmée',  location: 'ASOS UK' },
        ],
      },
      {
        id: 'line_4',
        emoji: '👜', name: 'Pochette velours',
        partner: 'ASOS', partnerId: 'asos',
        price: 65, size: 'Unique',
        status: 'confirmed',
        trackingNumber: null,
        carrier: null,
        estimatedDelivery: '2026-04-17',
        events: [
          { date: '2026-04-12T09:05:00', label: 'Commande confirmée',  location: 'ASOS UK' },
        ],
      },
    ],
    total: 113, deliveryAddress: 'Sofia · 12 rue de la Paix, 75001 Paris',
  },
];

/* ─── Helpers ─────────────────────────────────────────────── */

/** Formate une date en français */
export function formatDeliveryDate(isoDate) {
  if (!isoDate) return null;
  const d = new Date(isoDate);
  const options = { weekday: 'long', day: 'numeric', month: 'long' };
  return d.toLocaleDateString('fr-FR', options);
}

/** Calcule le % de progression d'une livraison */
export function deliveryProgress(status) {
  const map = {
    pending: 5, confirmed: 20, preparing: 40,
    shipped: 60, in_transit: 70, out_for_delivery: 90, delivered: 100,
    cancelled: 0, returned: 0,
  };
  return map[status] ?? 0;
}

/** Retourne les étapes attendues selon le statut actuel */
export function getDeliverySteps(currentStatus) {
  const steps = [
    { id: 'confirmed',         label: 'Confirmée' },
    { id: 'preparing',         label: 'Préparation' },
    { id: 'shipped',           label: 'Expédiée' },
    { id: 'in_transit',        label: 'En transit' },
    { id: 'out_for_delivery',  label: 'Livraison' },
    { id: 'delivered',         label: 'Livrée' },
  ];
  const order = ['confirmed','preparing','shipped','in_transit','out_for_delivery','delivered'];
  const currentIdx = order.indexOf(currentStatus);
  return steps.map((step, i) => ({
    ...step,
    done:    i <= currentIdx,
    active:  i === currentIdx,
  }));
}

/* ─── API Tracking (à brancher en production) ─────────────── */
/**
 * Récupère le statut de livraison depuis l'API du partenaire
 *
 * PRODUCTION — exemple pour Zalando :
 * GET https://api.zalando.com/orders/{orderId}/tracking
 * Headers: Authorization: Bearer {partner_token}
 *
 * Réponse :
 * {
 *   tracking_number: "ZLD123456",
 *   carrier: "DPD",
 *   estimated_delivery: "2026-04-14",
 *   status: "in_transit",
 *   events: [{ timestamp, description, location }]
 * }
 *
 * PRODUCTION — exemple pour ASOS :
 * GET https://api.asos.com/order/v4/{orderId}/tracking
 *
 * PRODUCTION — exemple pour Farfetch :
 * GET https://api.farfetch.net/v1/orders/{orderId}/fulfillments
 */
export async function fetchOrderTracking(orderId, partnerId) {
  // MOCK — en production remplacer par l'appel API réel
  const order = mockOrders.find(o => o.id === orderId);
  if (!order) throw new Error('Order not found');
  return order;
}

/**
 * Webhook partenaire → Outfit
 * Les partenaires envoient les mises à jour de statut à :
 * POST https://api.outfit.app/webhooks/delivery/{partnerId}
 *
 * Payload :
 * {
 *   outfit_order_id: "ord_001",
 *   partner_order_id: "ZLD-9876",
 *   status: "in_transit",
 *   tracking_number: "DHL1234567890",
 *   carrier: "DHL Express",
 *   estimated_delivery: "2026-04-14T18:00:00Z",
 *   event: { timestamp, description, location }
 * }
 *
 * L'Edge Function Supabase :
 * 1. Met à jour order_lines.status dans PostgreSQL
 * 2. Envoie une notification push si changement de statut
 * 3. Met à jour la date de livraison estimée
 */
